/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestSubmissionNotificationAction } from './FanRemixContestSubmissionNotificationAction';
import {
    FanRemixContestSubmissionNotificationActionFromJSON,
    FanRemixContestSubmissionNotificationActionFromJSONTyped,
    FanRemixContestSubmissionNotificationActionToJSON,
} from './FanRemixContestSubmissionNotificationAction';

/**
 * 
 * @export
 * @interface FanRemixContestSubmissionNotification
 */
export interface FanRemixContestSubmissionNotification {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestSubmissionNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestSubmissionNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof FanRemixContestSubmissionNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestSubmissionNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<FanRemixContestSubmissionNotificationAction>}
     * @memberof FanRemixContestSubmissionNotification
     */
    actions: Array<FanRemixContestSubmissionNotificationAction>;
}

/**
 * Check if a given object implements the FanRemixContestSubmissionNotification interface.
 */
export function instanceOfFanRemixContestSubmissionNotification(value: object): value is FanRemixContestSubmissionNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function FanRemixContestSubmissionNotificationFromJSON(json: any): FanRemixContestSubmissionNotification {
    return FanRemixContestSubmissionNotificationFromJSONTyped(json, false);
}

export function FanRemixContestSubmissionNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestSubmissionNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(FanRemixContestSubmissionNotificationActionFromJSON)),
    };
}

export function FanRemixContestSubmissionNotificationToJSON(value?: FanRemixContestSubmissionNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(FanRemixContestSubmissionNotificationActionToJSON)),
    };
}

